document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('.home_banner_swiper')) {
        new Swiper('.home_banner_swiper', {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: false,
            slidesPerView: 1,
        });
    }

 // eaudecoco_section
    if (document.querySelector('.index_banner_swiper')) {
        new Swiper('.index_banner_swiper', {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: false,
            slidesPerView: 1,
        });
    }


// home our featured product slider
     const featuredSwiper = new Swiper('.swiper.featured-collection-swiper', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      autoplay: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-feature',
        prevEl: '.swiper-button-prev-feature',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      }
      
    });
   

  //Home shop by category slider
  const categorySwiper = new Swiper('.featured-category-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    autoplay: false,
    navigation: {
      nextEl: '.swiper-button-next-cat',
      prevEl: '.swiper-button-prev-cat',
    },
    breakpoints: {
      481: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1140: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    }
  });

});